export default "__VITE_ASSET__5643c6f6__"